import { APP_BASE_SCHEME, APP_VARIANTS, getAppScheme } from './app-variants.js';
export const DEEP_LINK_DOMAIN = 'familychef.fr';
export const DEEP_LINK_SCHEME = APP_BASE_SCHEME;
/** Custom schemes of every build variant: `familychef`, `familychef-dev`, … */
export const DEEP_LINK_SCHEMES = APP_VARIANTS.map(getAppScheme);
export const DEEP_LINK_PREFIXES = [
    `${DEEP_LINK_SCHEME}://`,
    `https://${DEEP_LINK_DOMAIN}`,
    `http://${DEEP_LINK_DOMAIN}`,
];
export const DEEP_LINK_PATHS = {
    recipe: '/recipes/:id',
    invitation: '/invitation/:token',
    sharedRecipe: '/shared/:token',
    confirmDelete: '/confirm-delete/:token',
    menu: '/menu',
    shopping: '/shopping',
    account: '/account',
};
//# sourceMappingURL=deep-linking.js.map